<template>
  <div class="collapse-card">
    <a-collapse :bordered="false"
                accordion
                v-model="activeKey">
      <a-collapse-panel v-for="item in options"
                        :key="String(item.id)"
                        :showArrow="false"
                        class="collapse-item">
        <div slot="header"
             ref="panel"
             class="header-item"
             @mouseenter="handleClick(item.id)"
             @click="toDetail(item)">
          <span class="text">{{ item.title }}</span><span>{{ item.publishTime }}</span>
        </div>
        <p @click="toDetail(item)">{{ item.summary }}</p>
      </a-collapse-panel>
    </a-collapse>
    <div class="list-more"><span @click="toMore">更多></span></div>
  </div>
</template>
<script>
import { debounce } from '@/utils'
export default {
  props: {
    options: Array
  },
  data() {
    return {
      activeKey: ''
    }
  },
  watch: {
    options: {
      handler() {
        this.activeKey = this.options[0].id
      },
      deep: true,
      immediate: true
    }
  },
  // mounted() {
  //   this.activeKey = this.options[0].id
  // },
  methods: {
    // 处理鼠标进入item展开手风琴
    handleClick: debounce(function (id) {
      this.activeKey = String(id)
    }, 500),
    // 向外抛出跳转到详情页
    toDetail(item) {
      this.$emit('toDetail', item)
    },
    toMore() {
      this.$emit('toMore')
    }
  }
}
</script>
